import {i18n} from '@/plugins/i18n';
import { walletOpenBankingRequestStatusVariant, walletOpenBankingRequestStatusStr, walletOpenBankingRequestProviderStr} from "@/constants/WalletOpenBankingRequest";

export default [
    {
        field: 'id',
        title: i18n.t('label.identifier'),
        sortable: true,
        width: 50,
        type: 'number',
        selector: false,
        textAlign: 'center',
    },
    {
        field: 'provider_str',
        title: i18n.t('application.provider'),
        sortable: true,
        template: row => {
            return `<span dir="ltr">${row.provider_str}</span>`;
        },
        textAlign: 'center',
    },
    {
        field: 'service_str',
        title: i18n.t('open_banking.service'),
        sortable: true,
        template: row => {
            return `<span dir="ltr">${row.service_str}</span>`;
        },
        textAlign: 'center',
    },
    {
        field: 'status',
        title: i18n.t('label.status'),
        sortable: true,
        template: row => {
            return `
                <span class="badge badge-${walletOpenBankingRequestStatusVariant(row.status)}">
                    ${walletOpenBankingRequestStatusStr.get(row.status)}
                </span>
            `;
        },
        textAlign: 'center',
    },
    {
        field: 'created_at',
        title: i18n.t('label.created_at'),
        sortable: true,
        textAlign: 'center',
    },
    {
        field: 'caller_path',
        title: i18n.t('label.caller_path'),
        sortable: true,
        template: row => {
            return `<span dir="ltr">${row.caller_path}</span>`;
        },
        width: 400,
        textAlign: 'center',
    },
]
